
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ax0t7", function(module, exports) {

$parcel$export(module.exports, "CustomContentLoading", () => $85cd5e027d00e759$export$a9e8e6443d4a94e4);

var $gwFzn = parcelRequire("gwFzn");

var $9hlns = parcelRequire("9hlns");

var $7QbVE = parcelRequire("7QbVE");
const $85cd5e027d00e759$export$a9e8e6443d4a94e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7QbVE.SpinnerContainer), {
        "data-testid": "custom-content-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        size: "large"
    }));

});
parcelRegister("7QbVE", function(module, exports) {

$parcel$export(module.exports, "CustomContentTable", () => $292c7f6a07490589$export$7a9c0c987394c6b4);
$parcel$export(module.exports, "SpinnerContainer", () => $292c7f6a07490589$export$a5e06607a5ac6158);
$parcel$export(module.exports, "MessageContainer", () => $292c7f6a07490589$export$616d763e306cba45);
$parcel$export(module.exports, "MessageMain", () => $292c7f6a07490589$export$f37f0dbba01244f5);
$parcel$export(module.exports, "MessageSecondary", () => $292c7f6a07490589$export$b0b59a741f780696);
$parcel$export(module.exports, "CustomContentIcon", () => $292c7f6a07490589$export$a71b7f62b9b4a6c2);
/* SpaceCustomContentListView-styles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $7aA9P = parcelRequire("7aA9P");
const $292c7f6a07490589$export$7a9c0c987394c6b4 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1gky11bn _cnohdcr7 _opvxh8dc _10wbnkob _sni47vkz _xldf1w81 _15xm1w81 _a2nzh8dc _8k75nkob _1w80ajfg",
            __cmplp.className
        ])
    });
});
const $292c7f6a07490589$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $292c7f6a07490589$export$616d763e306cba45 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkoahv _1e0c1txw _4cvr1h6o _1bah1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $292c7f6a07490589$export$f37f0dbba01244f5 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_syaz1fxt _k48pmoej _19pkxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $292c7f6a07490589$export$b0b59a741f780696 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_syaz1fxt _19pk1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $292c7f6a07490589$export$a71b7f62b9b4a6c2 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $7aA9P.FallbackableImage), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7aA9P", function(module, exports) {

$parcel$export(module.exports, "FallbackableImage", () => $538583af869725c3$export$b170112dc71045f1);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");
class $538583af869725c3$export$b170112dc71045f1 extends (0, $gwFzn.PureComponent) {
    render() {
        const props = Object.assign({}, this.props);
        if ((this.state.error || !props.src) && props.fallback) {
            if (typeof props.fallback === 'string') props.src = props.fallback;
            else if (typeof props.fallback === 'function') return props.fallback();
        }
        delete props.fallback;
        // eslint-disable-next-line jsx-a11y/alt-text
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
            ...props,
            onError: this.onError
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
        this.onError = ()=>{
            this.setState({
                error: true
            });
        };
    }
}
$538583af869725c3$export$b170112dc71045f1.propTypes = {
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
    ])
};

});



parcelRegister("9G3cq", function(module, exports) {

$parcel$export(module.exports, "CustomContentErrorMessage", () => $5ee564f7700a9f66$export$9a0e4bba3f3dc24a);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $aoVih = parcelRequire("aoVih");

var $dIouf = parcelRequire("dIouf");

var $4R9QS = parcelRequire("4R9QS");
const $5ee564f7700a9f66$export$9a0e4bba3f3dc24a = ({ error: error })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aoVih.default), {
        appearance: "error",
        title: intl.formatMessage((0, $4R9QS.i18n).errorTitle)
    }, intl.formatMessage((0, $4R9QS.i18n).errorBody)));
};

});
parcelRegister("4R9QS", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $9b0d9eeb6a8091d6$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $9b0d9eeb6a8091d6$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    name: {
        id: "custom-content.custom-content-space-list-view.name",
        defaultMessage: "Name"
    },
    contributors: {
        id: "custom-content.custom-content-space-list-view.contributors",
        defaultMessage: "Contributors"
    },
    lastModified: {
        id: "custom-content.custom-content-space-list-view.lastModified",
        defaultMessage: "Last Modified"
    },
    noCustomContent: {
        id: "custom-content.custom-content-space-list-view.noResults",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "There's nothing here but potential"
    },
    timeToFill: {
        id: "custom-content.custom-content-space-list-view.timeToFill",
        defaultMessage: "Time to fill this space with something awesome."
    },
    noItems: {
        id: "custom-content.custom-content-space-list-view.noItems",
        defaultMessage: "No items"
    },
    errorTitle: {
        id: "custom-content.custom-content-space-list-view.errorTitle",
        defaultMessage: "Something went wrong."
    },
    errorBody: {
        id: "custom-content.custom-content-space-list-view.errorBody",
        defaultMessage: "Please try again later."
    }
});

});


parcelRegister("hSRMl", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $01a0d0611b8f7cfb$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getCustomContentSource", () => $01a0d0611b8f7cfb$export$774dcca1e8056ce0);
$parcel$export(module.exports, "ableToDeleteCustomContent", () => $01a0d0611b8f7cfb$export$a4c13e4be52c32cc);
$parcel$export(module.exports, "getIcon", () => $01a0d0611b8f7cfb$export$16b26cd5e98d9100);
$parcel$export(module.exports, "getCustomContentTypeForConnect", () => $01a0d0611b8f7cfb$export$63d785e75c867daa);

var $62ptY = parcelRequire("62ptY");

var $3UO79 = parcelRequire("3UO79");

var $fKAqd = parcelRequire("fKAqd");
const $01a0d0611b8f7cfb$export$3ae94a2503e890a1 = (date)=>{
    if (!date) return '';
    let formattedDate = '';
    try {
        formattedDate = (0, $62ptY.default)(new Date(date), 'PP kk:mm');
    } catch (e) {}
    return formattedDate;
};
const $01a0d0611b8f7cfb$export$774dcca1e8056ce0 = (type)=>{
    if (!type) return;
    const [prefix] = type.split(':');
    if (prefix === 'ac') return (0, $fKAqd.CustomContentSources).CONNECT;
    if (prefix === 'forge') return (0, $fKAqd.CustomContentSources).FORGE;
};
const $01a0d0611b8f7cfb$export$a4c13e4be52c32cc = ({ operations: operations, targetType: targetType })=>(0, (/*@__PURE__*/$parcel$interopDefault($3UO79)))(operations, {
        targetType: targetType,
        operation: 'delete'
    });
const $01a0d0611b8f7cfb$var$ABSOLUTE_PATH_REGEXP = new RegExp('^([a-z]+:)?//', 'i');
const $01a0d0611b8f7cfb$export$16b26cd5e98d9100 = (module)=>{
    let icon = module?.uiSupport?.icons?.item?.url;
    if (!$01a0d0611b8f7cfb$var$ABSOLUTE_PATH_REGEXP.test(icon)) icon = module?.baseUrl + icon;
    return icon;
};
const $01a0d0611b8f7cfb$export$63d785e75c867daa = (app)=>{
    return `ac:${app.addonKey}:${app.key}`;
};

});
parcelRegister("fKAqd", function(module, exports) {

$parcel$export(module.exports, "CustomContentSources", () => $3a7ddab342212797$export$d40a5573030af1a9);
var $3a7ddab342212797$export$d40a5573030af1a9 = /*#__PURE__*/ function(CustomContentSources) {
    CustomContentSources["CONNECT"] = "CONNECT";
    CustomContentSources["FORGE"] = "FORGE";
    return CustomContentSources;
}({});

});



//# sourceMappingURL=ByLineForgeApp.39b405e6.js.map
